import { DropsTabStatus, DropsFilter, DROPS_QUERY_KEY, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
export const isValidTab = (tab) => {
    return typeof tab === 'string' && Object.values(DropsTabStatus).includes(tab);
};
export const isValidFilter = (filter) => {
    return typeof filter === 'string' && Object.values(DropsFilter).includes(filter);
};
export const getDropsListQueryKey = (params) => [DROPS_QUERY_KEY.drops, params];
